import { Component, OnInit } from '@angular/core';
import { EnvironmentService } from 'src/app/services/environment.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-mere-filiale',
  templateUrl: './mere-filiale.component.html',
  styleUrls: ['./mere-filiale.component.scss']
})
export class MereFilialeComponent implements OnInit {

  constructor(private environmentService: EnvironmentService) { }
  
  PASSWORD_AES_ECRYPTION_KEY = this.environmentService.get().passwordAesEncryptionKey;
  
  ngOnInit(): void {
  }

}
